import { Box } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { IorderInfo } from "../..";
import { convertToJalali } from "../../../../../../../utils/functions";
import StartStep from "./StepItem";
export interface IStepItem {
  title: string;
  date?: string;
  status?: "pending" | "done" | "inprogress";
  index: number;
  description: string;
}

export default function GraphicalStatus(props: IorderInfo) {
  const { registrarsInfo } = props;

  const stepItems: IStepItem[] = [
    {
      title: "صدور مجوز",
      status: "done",
      date: convertToJalali(registrarsInfo.insertDateTime).split(" ")[1],
      index: 1,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "صدور حواله",
      status: "inprogress",
      date: "1403/05/08",
      index: 2,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "صدور بارنامه",
      status: "pending",
      date: "",
      index: 3,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "در مسیر مقصد",
      status: "pending",
      date: "",
      index: 3,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
    {
      title: "تحویل بار در <br/> مقصد",
      status: "pending",
      date: "",
      index: 4,
      description:
        "بارنامه برای بار شما از سمت شرکت حمل صادر شد و راننده برای دریافت بار به سمت انبار مبدا رفت.",
    },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "12px",
        border: "1px solid",
        borderColor: blueGrey[400],
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          // backgroundColor: "bgColor.grey100",
          display: "flex",
          paddingBottom: "0px",
          borderRadius: "8px",
          paddingX: "6px",
          gap: "3px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingY: "15px",
            width: "100%",
          }}
        >
          {stepItems.map((item) => (
            <StartStep {...item} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
